import { Grid, Skeleton, Typography } from '@mui/material';

import { useBreakpoint } from '../..//hooks/useBreakpoint/useBreakpoint';

type Props = {
  title?: string;
  children: React.ReactNode;
  colSpan?: number;
  isLoading?: boolean;
  variant?: 'primary' | 'emphasis';
  'data-testid'?: string;
};

export const DataCardItem = ({ title, children, colSpan, isLoading, variant = 'primary', ...rest }: Props) => {
  const { isMobile } = useBreakpoint();

  const defaultColSpan = isMobile ? 6 : 4;

  return (
    <Grid display="flex" flexDirection="column" gap={1} item xs={colSpan ?? defaultColSpan} pb={2} {...rest}>
      {isLoading ? <Skeleton height={40} width="100%" /> : null}
      {title ? (
        <Typography
          fontWeight="bold"
          variant={variant === 'emphasis' ? 'h5' : 'body2'}
          textAlign={variant === 'emphasis' ? 'center' : 'left'}
        >
          {title}
        </Typography>
      ) : null}
      <Typography
        variant="body2"
        textAlign={variant === 'emphasis' ? 'center' : 'left'}
        color="inherit"
        component="div"
      >
        {children}
      </Typography>
    </Grid>
  );
};
